import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';

import { CreateJobTypeComponent} from './../create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';
import { JobSubjectServiceType } from '../../../../shared/models/jobSubjectServiceType.model';

@Component({
  selector: 'app-create-subject-service-type',
  templateUrl: './create-subject-service-type.component.html',
  styleUrls: ['./create-subject-service-type.component.css']
})
export class CreateSubjectServiceTypeComponent implements OnInit {

  model: JobSubjectServiceType;
  job_types: Object;
  job_type_locations: Object;
  count2: any;
  get_latest_court_id: Object;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  get_latest_document_id: Object;
  job_type_affidavit_types: Object;
  sent_job_type_document_type_id: any;
  get_latest_type_id: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  get_latest_subject_service_type_id: Object;
  job_service_rules: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef
  ) { }

  ngOnInit() {

    this.model = new JobSubjectServiceType();
    this.getJobServiceRules();
  }



  getJobServiceRules() {
    this._demoService.getJobServiceRules().subscribe(
       data => { this.job_service_rules = data; },
       err => console.error(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }


  createSubjectServiceType(model) {
    // console.log(model);
        this._demoService.createSubjectServiceType(model).subscribe(
             data => {  this.get_latest_subject_service_type_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Subject Service Type Failed :: Please try again!');
               console.log(error);
                              // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Subject Service Type Added');
       };
 



}
